import {
  CheckBox,
  TurtleTheme,
  useTurtleTheme,
} from '@dmm-com/turtle-components'
import { css } from '@emotion/react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  name: string
  defaultChecked: boolean
}

export const Newsletter = ({ name, defaultChecked, ...rest }: Props) => {
  const theme = useTurtleTheme()
  const styles = createStyles(theme)
  return (
    <section css={styles.newsletterSection} {...rest}>
      <p css={styles.h6}>DMM 3D プリント メールマガジンについて</p>
      <p css={styles.body1}>
        DMM
        3Dプリントの素材追加・キャンペーン情報などをご案内するメールマガジンです。ご登録されたメールアドレス宛に、合同会社DMM.comよりお送りいたします。
      </p>
      <CheckBox
        id={name}
        checkBoxProps={{
          name: name,
        }}
        css={styles.newsletterCheckBox}
        defaultChecked={defaultChecked}
        label="DMM 3Dプリント メールマガジンを受信する"
      />
    </section>
  )
}

const createStyles = (theme: TurtleTheme) => {
  const { spacing } = theme.turtle
  return {
    h6: css`
      ${theme.turtle.typography.heading6};
      margin-bottom: ${theme.turtle.spacing.small[5]};
    `,
    body1: css`
      ${theme.turtle.typography.body1};
    `,
    newsletterSection: css`
      background-color: ${theme.turtle.palette.surfaceColor.primarySurface};
      border-radius: ${theme.turtle.borderRadius.small};
      padding: ${spacing.medium[2]};
    `,
    newsletterCheckBox: css`
      margin-top: ${spacing.small[5]};
    `,
  }
}
